<template>
    <div id="comptes">
        <b-row class="backInfoMain2">

            <s-menuSave :msg="sendMsg" newBtn :btnSaveDisabled="checkAllField" @new="menuNew()" saveBtn @save="menuSave()" :deleteBtn="checkDeleteBtn" @delete="menuDelete(activeObj.id)"></s-menuSave>

            <!--Section de gauche-->
            <b-col :xs="pSize.left.xs" :sm="pSize.left.sm" :md="pSize.left.md" :lg="pSize.left.lg" :xl="pSize.left.xl">
                <s-itemList
                    v-if="accountList" 
                    :content="accountList" 
                    :returnValue.sync="activeObj" 
                    showField="number" 
                    showField2="description0" 
                    activeField="isActive" 
                    returnField="id"
                    :selectedItems="activeObj"
                    getSubCol="description0"
                    multiColonne
                    :fields="fields"
                    @subMethodsReturn="check()">
                </s-itemList>
            </b-col>
            <!--Fin section de gauche-->

<!--****************************************************************************************************************************************************************-->
            
            <!--Section de droite-->
            <b-col :class="getAllSize.pagePadTop" :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" :xl="pSize.right.xl">

                <!--ACTIF-->    
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="5">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('cmp_Actif')}}</div>
                            <div class="itemContain">
                                <s-duoSelector style="margin-left: -15px" :text1="$t('cmp_Actif')" :text2="$t('cmp_Inactif')" invertTrueFalse :value="activeObj.isActive" :returnValue.sync="activeObj.isActive"></s-duoSelector>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!--FIN - ACTIF-->    
                
                <!--SOLDE-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="5">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('acc_Solde')}}</div>
                            <div class="itemContain">
                                <span class="solde txtSign">0.00$</span>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!--FIN - SOLDE-->

                <!--NUMERO DE COMPTE-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="5">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('acc_NumeroDeCompte')}}</div>
                            <div class="itemContain">

                                <b-row align-v="center" class="txtSignInactive backNumber">
                                    <b-col cols="7" xs="4" sm="4" md="4" lg="4" :xl="numberWidth">{{otherAccount.previousNumber}}</b-col> 
                                    <b-col :cols="numberWidth" style="margin-left: -5px;">{{otherAccount.previousName}}</b-col> 
                                </b-row>

                                <b-row align-v="center" class="txtSign" style="margin-bottom: 15px; margin-top: 10px;">
                                    <b-col cols="7" xs="4" sm="4" md="4" lg="4" :xl="numberWidth">
                                        <b-input-group class="mb-2">
                                                <b-form-input class="txtPrincipal" :state="activeObj.number.length > 0 ? true : false" id="accountNumber" name="accountNumber" type="text" maxlength="15" :placeholder="$t('acc_Numero')" v-model="activeObj.number" @input="getNextPeviousAccount(true, activeObj.number, false)">
                                                </b-form-input>
                                           
                                            <!--BOUTON MODIFIER-->
                                            <b-input-group-append @click="txtRecherche = ''" style="height: 38px; margin-top: 5px">
                                                <b-button :disabled="activeObj.id == 0 ? true : false" @click="$bvModal.show('modal-1'), clearNextPrevModif(), changeNumber=''"><b-icon icon="gear-fill" scale="1" style="margin-top: 2px"></b-icon></b-button>
                                                <!--<b-icon icon="gear-fill" scale="1" @click="$bvModal.show('modal-1'), clearNextPrevModif(), changeNumber=''"></b-icon>-->
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col> 
                                    <b-col :cols="numberWidth">{{activeObj.description0}}</b-col> 
                                </b-row>

                                <b-row align-v="center" class="txtSignInactive backNumber">
                                    <b-col cols="7" xs="4" sm="4" md="4" lg="4" :xl="numberWidth">{{otherAccount.nextNumber}}</b-col> 
                                    <b-col :cols="numberWidth" style="margin-left: -5px;">{{otherAccount.nextName}}</b-col> 
                                </b-row>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!--FIN - NUMERO DE COMPTE-->

                <!--INFORMATIONS-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="5">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('acc_Description')}}</div>
                            <div class="itemContain">
                                <s-comboFix name="typeCompte" :content="getCombo.cboAccountType" :title="$t('acc_Categories')" :value.sync="activeObj.categoryTypeId"></s-comboFix>
                                <b-form-input class="txtPrincipal" :state="activeObj.description0.length > 0 ? true : false" id="description0" name="description0" type="text" maxlength="255" :placeholder="$t('acc_Description1')" v-model="activeObj.description0"></b-form-input>
                                <b-form-input class="txtPrincipal" id="description1" name="description1" type="text" maxlength="255" :placeholder="$t('acc_Description2')" v-model="activeObj.description1"></b-form-input>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!--FIN - INFORMATIONS-->

                <!--OUVERTURE-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="5">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('acc_Ouverture')}}</div>
                            <div class="itemContain">
                                <b-row align-v="center" class="txtSign">
                                    <b-col cols="7" xs="4" sm="4" md="4" lg="4" :xl="soldeOuvertureWidth" style="margin-left: -15px;">
                                        <s-currencyInput class="Prix" append="$" decimal="2" v-model="activeObj.openBalance"></s-currencyInput>
                                    </b-col>
                                </b-row>
                                
                                <!--<s-currencyInput class="Prix" append="$" decimal="2" v-model="activeObj.balance"></s-currencyInput>-->
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!--FIN- OUVERTURE-->

                <!--MODIFICATION DU NUMÉRO DE COMPTE-->
                <b-modal :body-bg-variant="getTheme.light" :header-bg-variant="getTheme.dark" :header-text-variant="getTheme.light" id="modal-1" :title="$t('acc_NouveauNumeroDeCompte')" hide-footer>
                    <b-row align-v="center" class="txtSignInactive backNumber">
                        <b-col cols="7" xs="4" sm="4" md="4" lg="4" xl="4">{{otherAccountModif.previousNumber}}</b-col> 
                        <b-col cols="4" style="margin-left: -5px;">{{otherAccountModif.previousName}}</b-col> 
                    </b-row>

                    <b-row align-v="center" class="txtSign" style="margin-bottom: 15px; margin-top: 10px;">
                        <b-col cols="7" xs="4" sm="4" md="4" lg="4" xl="4">
                            <b-form-input class="txtPrincipal" :state="changeNumber.length > 0 && isExist == false ? true : false" id="accountNumberChange" name="accountNumberChange" type="text" maxlength="15" :placeholder="$t('acc_Numero')" v-model="changeNumber" @input="getNextPeviousAccount(false, changeNumber, true)"/>
                        </b-col>
                        <b-col cols="4">{{activeObj.description0}}</b-col> 
                    </b-row>
                    
                    <b-row align-v="center" class="txtSignInactive backNumber">
                        <b-col cols="7" xs="4" sm="4" md="4" lg="4" xl="4">{{otherAccountModif.nextNumber}}</b-col> 
                        <b-col cols="4" style="margin-left: -5px;">{{otherAccountModif.nextName}}</b-col> 
                    </b-row>
                    <!--BOUTON Annuler / Enregistrer-->
                    <b-row align-v="center" style="margin-top: 15px">
                        <b-col cols="6" align="start">
                            <b-button style="width: 140px; margin-right: 10px" variant="danger" @click="closeChangeCompte()">{{$t('g_Annuler')}}</b-button>
                        </b-col>
                        <b-col cols="6" align="end">
                            <b-button style="width: 140px;" variant="success" @click="updateNumber()">{{$t('g_Enregistrer')}}</b-button>
                        </b-col>
                    </b-row>
                </b-modal>
                <!--FIN - MODIFICATION DU NUMÉRO DE COMPTE-->

                <!--TAXES-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="5">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('acc_Taxes')}}</div>
                                <div class="itemContain">
                                    <s-taxes
                                        :taxF.sync="activeObj.taxF"
                                        :taxP.sync="activeObj.taxP"
                                        :taxFInclude.sync="activeObj.taxFInclude"
                                        :taxPInclude.sync="activeObj.taxPInclude"
                                        :taxMotel.sync="activeObj.taxMotel"
                                        :taxTire.sync="activeObj.taxTire"
                                    ></s-taxes>
                                </div>
                        </div>
                    </b-col>
                </b-row>
                <!--FIN - TAXES-->

                <!--{{activeObj}}-->

            </b-col>
            <!--FIN - Section de droite-->
            
            
            <br><br>
            
        </b-row>
    </div>
</template>

<script>
import mapGetter from '../../../../mixins/getters.js'
import {dataService} from '@/services'
import store from '@/store'


export default{
    name: "comptes",
    mixins:[mapGetter],
    components: {

    },
    data() {
        return{
            apiAddGet1: this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.magasin.apiComptes, //adress de la requete principale vers l'API
            apiAddPost1: this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.magasin.apiComptes, //adress de la requete principale vers l'API
            pSize: this.$store.getters.getPageSize, //Taille des section droite/gauche
            chkSize: this.$store.getters.getCheckSize,
            sendMsg: '', //message a utiliser pour le menu en haut de la page New/Save/Delete
            output: 'null', //Message de reception de l'API
            error: null, //Message d'erreur de l'API
            //fromApi: null, //Contenu de l'API
            InitialState: null, //Format initial de : activeObj
            tempState: null,
            //Objet en cours de modification
            otherAccount: {
                previousNumber: '',
                previousName: '',
                nextNumber: '',
                nextName: ''
            },
            otherAccountModif: {
                previousNumber: '',
                previousName: '',
                nextNumber: '',
                nextName: ''
            },
            changeNumber: '',
            isExist: false,
            fields: [
                {
                    colName : "id",
                    label: "g_id",
                    width: 75,
                },
                {
                    colName : "number",
                    alignH : "left",
                    label: "acc_Numero",
                    width: 150,
                    show: true,
                },
                {
                    colName : "description0",
                    alignH : "left",
                    label: "acc_Description1",
                    show: true,
                },
                {
                    colName : "description1",
                    alignH : "left",
                    label: "acc_Description2",
                }
                
            ],
            activeObj:{
                id: 0,
                isActive: true,
                number: '',
                categoryTypeId: 0,
                description0: '',
                description1: '',
                checkNumber: 0,
                depositeNumber: 0,
                openBalance: 0,
                balance: 0,
                taxF: false,
                taxFInclude: false,
                taxP: false,
                taxPInclude: false,
                taxMotel: false,
                taxTire: false
            }
        }
    },
    methods: {
        pushto(link) {
            this.$router.push(link)
        },
        closeChangeCompte(){
            this.changeNumber = ''
            this.clearNextPrevModif()
            this.$bvModal.hide('modal-1')
        },
        resetAll(){
            this.activeObj = this.$CObj(this.InitialState)
            this.clearNextPrev()
            this.clearNextPrevModif()
        },
        clearNextPrev(){
            this.otherAccount.previousNumber = ''
            this.otherAccount.previousName = ''
            this.otherAccount.nextNumber = ''
            this.otherAccount.nextName = ''
        },
        check(){
            this.getNextPeviousAccount(true, this.activeObj.number, false)
        },
        updateNumber(){
            this.activeObj.number = this.changeNumber
            this.menuSave()
            this.closeChangeCompte()
        },
        clearNextPrevModif(){
            this.otherAccountModif.previousNumber = ''
            this.otherAccountModif.previousName = ''
            this.otherAccountModif.nextNumber = ''
            this.otherAccountModif.nextName = ''
        },
        menuNew(){
            this.resetAll()
        },
        loadApi() {
            this.sendMsg = '4'
            dataService.getLGAccounts().then( statusText =>{
                if(statusText == "OK") {
                    this.sendMsg = '';
                }
            }).catch(e => {
                  this.errors.push(e)
                  this.sendMsg = '2'
            })
        },
        menuSave(){
            this.sendMsg = '-'
            let t = this.activeObj

            if (t.id == 0) //CRÉATION D'UN NOUVEAU
            {
                dataService.addGLAccount(t)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        if(response.data)
                        {
                            const newGLAccount = response.data.data
                            this.accountList.unshift(newGLAccount)
                            this.$store.dispatch('updateGLAccounts', this.accountList)
                            this.resetAll()
                        }
                    }
                    this.sendMsg = ''
                })
                .catch((error) => {
                    this.sendMsg = error
                });
            }
            else //MODIFICATION D'UN EXISTANT
            {
                dataService.updateGLAccount(t)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        if(response.data)
                        {
                            const updatedGLAccount = response.data.data
                            this.accountList = this.accountList.map(acc => {
                                if(acc.id == updatedGLAccount.id)  Object.assign(acc, updatedGLAccount) ;
                                return acc;
                            });
                            this.$store.dispatch('updateGLAccounts', this.accountList)
                            this.resetAll()
                        }
                    }
                    this.sendMsg = ''
                })
                .catch((error) => {
                    this.sendMsg = error
                });
            }
            setTimeout(() => { this.sendMsg = '' }, 5000)
        },
        menuDelete(id){
            if (this.activeObj.id != '0')
                {
                    this.sendMsg = '-'
                    this.output = null

                    dataService.deleteGLAccount(this.activeObj.id)
                    .then((response) => {
                        if(response.statusText == 'OK')
                        {
                            if(response.data)
                            {
                                this.accountList = this.accountList.map(acc => {
                                    if(acc.id == id)  acc.isActive = !acc.isActive;
                                    return acc;
                                });
                                this.$store.dispatch('updateGLAccounts', this.accountList)
                                this.resetAll() 
                            }
                        }
                        this.sendMsg = ''
                    })
                    .catch((error) => {
                        this.sendMsg = error
                    });

                    setTimeout(() => { this.sendMsg = '' }, 5000)

                }
        },
        getNextPeviousAccount(loadExist, number, modifNumber){
            
            this.isExist = false

            var tempNumber = number

            if (number != '')
            {
                var accountValue = [];
                var i;
                var j;
                var fromApiID = 0;

                //Création d'une liste avec seulement les numéro de compte
                for(i=0; i<this.accountList.length; i++)
                {
                    accountValue.push(this.accountList[i].number)

                    if(number == this.accountList[i].number){fromApiID = i}
                }

                //Vérifier si le compte existe dans la liste ou non
                var f
                //var isExist = false
                
                for(f=0; f<accountValue.length; f++)
                {
                    if (number == accountValue[f])
                    {this.isExist = true}
                }

                //Si n'existe pas on l'ajoute à la liste
                if (this.isExist == false)
                {
                    accountValue.push(number)
                    //this.resetAll()
                }

                //Classer la liste temporaire des comptes en ordre
                accountValue = accountValue.sort((a, b) => a - b);

                //Vérifier les compte avant et après celui qui est écris ou sélectionné
                for(j=0; j<accountValue.length; j++)
                {
                    if(number == accountValue[j])
                        {
                            if(j != 0)
                                {
                                    if (modifNumber == false)
                                    {this.otherAccount.previousNumber = accountValue[j - 1]}
                                    else
                                    {this.otherAccountModif.previousNumber = accountValue[j - 1]}

                                    var x
                                    for(x=0; x<this.accountList.length; x++)
                                    {
                                        if (this.accountList[x].number == accountValue[j - 1])
                                        {
                                            if (modifNumber == false)
                                            {this.otherAccount.previousName = this.accountList[x].description0}
                                            else
                                            {this.otherAccountModif.previousName = this.accountList[x].description0}
                                        }
                                    }
                                }
                            else
                                {
                                    if (modifNumber == false)
                                    {
                                        this.otherAccount.previousNumber = ''
                                        this.otherAccount.previousName = ''
                                    }
                                    else
                                    {
                                        this.otherAccountModif.previousNumber = ''
                                        this.otherAccountModif.previousName = ''
                                    }
                                }

                            if(j != accountValue.length - 1)
                                {

                                    if (modifNumber == false)
                                    {this.otherAccount.nextNumber = accountValue[j + 1]}
                                    else
                                    {this.otherAccountModif.nextNumber = accountValue[j + 1]}

                                    var z
                                    for(z=0; z<this.accountList.length; z++)
                                    {
                                        if (this.accountList[z].number == accountValue[j + 1])
                                        {
                                            if (modifNumber == false)
                                            {this.otherAccount.nextName = this.accountList[z].description0}
                                            else
                                            {this.otherAccountModif.nextName = this.accountList[z].description0}
                                        }
                                    }
                                }
                            else
                                {
                                    if (modifNumber == false)
                                    {
                                        this.otherAccount.nextName = ''
                                        this.otherAccount.nextNumber = ''
                                    }
                                    else
                                    {
                                        this.otherAccountModif.nextName = ''
                                        this.otherAccountModif.nextNumber = ''
                                    }
                                }
                            
                        }
                }

                if(loadExist == true)
                {
                    if (this.isExist == true)
                    {
                            this.activeObj = this.$CObj(this.accountList[fromApiID])
                    }
                    else
                    {
                        if (this.activeObj.id != 0)
                        {
                            this.resetAll()
                            number = tempNumber
                        }
                    }
                }

            }
            else
            {
                if (modifNumber == false)
                {
                    this.clearNextPrev()
                }
                else
                {
                    this.clearNextPrevModif()
                }
            }
        },
        getNextPeviousAccount2(loadExist){
            
            var tempNumber = this.activeObj.number

            if (this.activeObj.number != '')
            {
                var accountValue = [];
                var i;
                var j;
                var fromApiID = 0;

                //Création d'une liste avec seulement les numéro de compte
                for(i=0; i<this.accountList.length; i++)
                {
                    accountValue.push(this.accountList[i].number)

                    if(this.activeObj.number == this.accountList[i].number){fromApiID = i}
                }

                //Vérifier si le compte existe dans la liste ou non
                var f
                var isExist = false
                
                for(f=0; f<accountValue.length; f++)
                {
                    if (this.activeObj.number == accountValue[f])
                    {isExist = true}
                }

                //Si n'existe pas on l'ajoute à la liste
                if (isExist == false)
                {
                    accountValue.push(this.activeObj.number)
                    //this.resetAll()
                }

                //Classer la liste temporaire des comptes en ordre
                accountValue = accountValue.sort((a, b) => a - b);


                //Vérifier les compte avant et après celui qui est écris ou sélectionné
                for(j=0; j<accountValue.length; j++)
                {
                    if(this.activeObj.number == accountValue[j])
                        {
                            if(j != 0)
                                {
                                    this.otherAccount.previousNumber = accountValue[j - 1]

                                    var x
                                    for(x=0; x<this.accountList.length; x++)
                                    {
                                        if (this.accountList[x].number == accountValue[j - 1])
                                        {this.otherAccount.previousName = this.accountList[x].description0}
                                    }
                                }
                            else
                                {
                                    this.otherAccount.previousNumber = ''
                                    this.otherAccount.previousName = ''
                                }

                            if(j != accountValue.length - 1)
                                {
                                    this.otherAccount.nextNumber = accountValue[j + 1]

                                    var z
                                    for(z=0; z<this.accountList.length; z++)
                                    {
                                        if (this.accountList[z].number == accountValue[j + 1])
                                        {this.otherAccount.nextName = this.accountList[z].description0}
                                    }
                                }
                            else
                                {
                                    this.otherAccount.nextName = ''
                                    this.otherAccount.nextNumber = ''
                                }
                            
                        }
                }

                if(loadExist == true)
                {
                    if (isExist == true)
                    {
                            this.activeObj = this.$CObj(this.accountList[fromApiID])
                    }
                    else
                    {
                        if (this.activeObj.id != 0)
                        {
                            this.resetAll()
                            this.activeObj.number = tempNumber
                        }
                    }
                }

            }
            else
            {
                this.clearNextPrev()
            }
        },
    },

 //------------------------------------------------------------------------------------------------
    computed: {
        checkAllField() {
            if (this.activeObj.description0 == '' || this.activeObj.description0 == null || this.activeObj.number == '' || this.activeObj.number == null)
            {return true}
            else
            {return false}
        },
        checkDeleteBtn() {
            return (this.activeObj.id != 0)
        },
        numberWidth(){
            if (this.getScreenSize.width >= 2100)
            {return 4}
            else if (this.getScreenSize.width < 2100 && this.getScreenSize.width >= 1800 )
            {return 5}
            else if (this.getScreenSize.width < 1800 && this.getScreenSize.width >= 1200 )
            {return 5}
            else if (this.getScreenSize.width < 1200 && this.getScreenSize.width >= 1000 )
            {return 5}
            else if (this.getScreenSize.width < 1000 && this.getScreenSize.width >= 700 )
            {return 5}
            else
            {return 5}
        },
        soldeOuvertureWidth(){
            if (this.getScreenSize.width >= 2100)
            {return 5}
            else if (this.getScreenSize.width < 2100 && this.getScreenSize.width >= 1800 )
            {return 6}
            else if (this.getScreenSize.width < 1800 && this.getScreenSize.width >= 1200 )
            {return 6}
            else if (this.getScreenSize.width < 1200 && this.getScreenSize.width >= 1000 )
            {return 6}
            else if (this.getScreenSize.width < 1000 && this.getScreenSize.width >= 700 )
            {return 6}
            else
            {return 6}
        },
        accountList : () => store.getters.getCompteGL
    },
//------------------------------------------------------------------------------------------------
    mounted() {
        this.loadApi() //charger les licences
        this.InitialState = this.$CObj(this.activeObj)
    },
//------------------------------------------------------------------------------------------------
    watch: {
        sendMsg: function() {
            if (this.sendMsg == '1')
            {
                this.resetAll()
                this.loadApi()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/views/account.scss';


</style>